import RoomsService from "services/RoomsService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getRooms = createAsyncThunk(
    "rooms/getAll",
    async (_, { rejectWithValue }) => {
        try {
            const response = await RoomsService.getRooms();
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const getRoomById = createAsyncThunk(
    "rooms/getRoomById",
    async (id, { rejectWithValue }) => {
        try {
            const response = await RoomsService.getRoomById(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

export const createRoom = createAsyncThunk(
    "rooms/createRoom",
    async (data, { rejectWithValue }) => {
        try {
            const response = await RoomsService.createRoom(data);
            return response.data.salle;
        } catch (error) {
            return rejectWithValue(error.response.data.error || "Erreur");
        }
    }
);

export const updateRoomById = createAsyncThunk(
    "rooms/updateRoomById",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await RoomsService.updateRoom(id, data);
            return response.data.salles;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Erreur");
        }
    }
);

export const deleteRoomById = createAsyncThunk(
    "rooms/deleteRoomById",
    async (id, { rejectWithValue }) => {
        try {
            // TODO: this is supposed to return the deleted room id, but the API returns only a status message
            await RoomsService.deleteRoomById(id);
            return id;
        } catch (error) {
            return rejectWithValue(error.response || "Erreur");
        }
    }
);

const initialState = {
    rooms: [],
    room: null,
    loading: false,
    error: null,
};

const roomsSlice = createSlice({
    name: "rooms",
    initialState,
    reducers: {
        setRooms: (state, { payload }) => {
            state.rooms = payload;
        },
        setRoom: (state, { payload }) => {
            state.room = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },
    extraReducers: {
        [getRooms.pending]: (state) => {
            state.loading = true;
        },
        [getRooms.fulfilled]: (state, { payload }) => {
            state.rooms = payload;
            state.loading = false;
        },
        [getRooms.rejected]: (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        },
        [getRoomById.pending]: (state) => {
            state.loading = true;
        },
        [getRoomById.fulfilled]: (state, { payload }) => {
            state.room = payload;
            state.loading = false;
        },
        [getRoomById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [createRoom.pending]: (state, { payload }) => {
            state.loading = true;
        },
        [createRoom.fulfilled]: (state, { payload }) => {
            state.rooms.push(payload);
            state.loading = false;
        },
        [createRoom.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [updateRoomById.pending]: (state) => {
            state.loading = true;
        },
        [updateRoomById.fulfilled]: (state, { payload }) => {
            state.rooms = state.rooms.map((room) =>
                room._id === payload._id ? payload : room
            );
            state.loading = false;
        },
        [updateRoomById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
        [deleteRoomById.pending]: (state) => {
            state.loading = true;
        },
        [deleteRoomById.fulfilled]: (state, { payload }) => {
            state.rooms = state.rooms.filter((room) => room._id !== payload);
            state.loading = false;
        },
        [deleteRoomById.rejected]: (state, { payload }) => {
            state.loading = false;
        },
    },
});

export const { setRooms, setRoom, setLoading, setError } = roomsSlice.actions;

export default roomsSlice.reducer;
